import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Entries() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Entries
			</Text>
			<Text variant='caption' gutterBottom>
				Entries
			</Text>
		</Paper>
	)
}
export default Entries
